import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
  OnDestroy,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Customer } from 'server/shared/models/customer';
import { ReportsEnum } from 'server/shared/models/reports.enum';
import { CustomerService } from '../../services/customer.service';
import { PermissionsService } from '../../services/permissions.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'admin-reports',
  templateUrl: 'admin-reports.component.html',
  styleUrls: ['admin-reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminReportsComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();

  customer$ = this.customerService.readyDispoCustomer$;

  // Report keys exclude the internal only reports
  reportKeys = Object.values(ReportsEnum).filter(
    (report) => report !== ReportsEnum.JOBS_FOR_INVOICE,
  ) as ReportsEnum[];

  constructor(
    private permissionsService: PermissionsService,
    private customerService: CustomerService,
    private toastService: ToastService,
    private ngZone: NgZone,
    private location: Location,
  ) {
    this.permissionsService.isCustomerAdmin$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isCustomerAdmin) => {
        if (!isCustomerAdmin) {
          this.historyBack();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  historyBack(): void {
    this.location.back();
  }

  trackByReport(_index: number, report: ReportsEnum): string {
    return report;
  }

  isReportEnabled(report: ReportsEnum, customer: Customer): boolean {
    return !(customer.hiddenReports?.includes(report) ?? false);
  }

  areAllReportsDisabled(customer: Customer): boolean {
    if (this.reportKeys.length === 0) {
      return false;
    }
    const hidden = customer.hiddenReports ?? [];
    return this.reportKeys.every((report) => hidden.includes(report));
  }

  onReportVisibilityChange(
    report: ReportsEnum,
    visible: boolean,
    customerId: string,
  ): void {
    const method = visible
      ? 'removeCustomerHiddenReport'
      : 'addCustomerHiddenReport';
    Meteor.call(method, customerId, report, (error?: Meteor.Error) => {
      this.ngZone.run(() => {
        if (error) {
          this.toastService.add({ type: 'ERROR', message: 'serverError' });
        }
      });
    });
  }
}
